var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDropIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_11414_120995)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11414_120995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.765 6.79503L28.715 3.80337C28.8332 3.78641 28.9537 3.79506 29.0683 3.82874C29.1829 3.86242 29.2889 3.92035 29.3792 3.99859C29.4694 4.07683 29.5418 4.17355 29.5914 4.28221C29.641 4.39087 29.6667 4.50892 29.6667 4.62837V39.3717C29.6666 39.491 29.641 39.6089 29.5915 39.7174C29.542 39.8259 29.4698 39.9226 29.3797 40.0008C29.2897 40.079 29.1839 40.1369 29.0695 40.1707C28.9551 40.2045 28.8348 40.2134 28.7167 40.1967L7.76333 37.205C7.36603 37.1484 7.00249 36.9504 6.73948 36.6473C6.47647 36.3442 6.33167 35.9563 6.33167 35.555V8.44503C6.33167 8.04372 6.47647 7.65589 6.73948 7.35277C7.00249 7.04966 7.36603 6.85162 7.76333 6.79503H7.765ZM9.66666 9.8917V34.1084L26.3333 36.49V7.51003L9.66666 9.8917ZM31.3333 33.6667H36.3333V10.3334H31.3333V7.00003H38C38.442 7.00003 38.8659 7.17563 39.1785 7.48819C39.4911 7.80075 39.6667 8.22467 39.6667 8.6667V35.3334C39.6667 35.7754 39.4911 36.1993 39.1785 36.5119C38.8659 36.8244 38.442 37 38 37H31.3333V33.6667ZM20 22L24.6667 28.6667H20.6667L18 24.8567L15.3333 28.6667H11.3333L16 22L11.3333 15.3334H15.3333L18 19.1434L20.6667 15.3334H24.6667L20 22Z",
    fill: "#18223D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11414_120995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.48 40.5961L51.024 48.1374L49.1373 50.0241L41.596 42.4814L34.996 49.0814V33.9961H50.08L43.48 40.5961Z",
    fill: "#18223D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_11414_120995",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11414_120995"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11414_120995",
    result: "effect2_dropShadow_11414_120995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11414_120995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11414_120995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(3 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11414_120995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(27 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDropIcon);
export default __webpack_public_path__ + "static/media/upload-drop-icon.2c2796a6d63b6e61ff11752075578f5c.svg";
export { ForwardRef as ReactComponent };